import { useDispatch, useSelector } from "react-redux";

import CrmEnrichmentJobTypeWizardStep from "app/pages/sales-intelligence/modules/crm-enrichment/components/wizard/CrmEnrichmentJobTypeWizardStep";
import { useCrmEnrichmentContext } from "app/pages/sales-intelligence/modules/crm-enrichment/contexts/CrmEnrichmentContext";
import crmEnrichmentTrackingService from "app/pages/sales-intelligence/modules/crm-enrichment/services/tracking/trackingService";
import { setSelectedJobType } from "app/pages/sales-intelligence/modules/crm-enrichment/store/action-creators";
import { selectSelectedJobType } from "app/pages/sales-intelligence/modules/crm-enrichment/store/selectors";

import type { CrmEnrichmentJobType } from "../../../types/types";

const CrmEnrichmentJobTypeWizardStepContainer = () => {
    const dispatch = useDispatch();

    const { crmProvider } = useCrmEnrichmentContext();

    const selectedJobType = useSelector(selectSelectedJobType);

    const handleUpdateJobType = (type: CrmEnrichmentJobType) => {
        crmEnrichmentTrackingService.wizard.trackSelectType(type, crmProvider);

        dispatch(setSelectedJobType(type));
    };

    return (
        <CrmEnrichmentJobTypeWizardStep
            crmProvider={crmProvider}
            selectedJobType={selectedJobType}
            onSelectedJobType={handleUpdateJobType}
        />
    );
};

export default CrmEnrichmentJobTypeWizardStepContainer;
